import React from 'react'
import B2BLeadForm from '../../../components/B2BLeadForm'
import type { Lang } from './types'

interface Props {
  currentLang: Lang
}

/**
 * B2B sample-request CTA + form — V2 visual treatment (cream background,
 * serif headings) wrapping the existing B2BLeadForm to keep email +
 * lead-flow logic (and 'service@ongucoffee.com' notification) untouched.
 */
const WholesaleApplyFormV2: React.FC<Props> = ({ currentLang }) => {
  const steps = [
    {
      step: '01',
      title: currentLang === 'zh' ? '填表申請' : 'Submit Form',
      desc: currentLang === 'zh' ? '2 分鐘完成' : '2 min to complete',
    },
    {
      step: '02',
      title: currentLang === 'zh' ? '樣本寄出' : 'Sample Shipped',
      desc: currentLang === 'zh' ? '24hr 內安排' : 'Arranged in 24hr',
    },
    {
      step: '03',
      title: currentLang === 'zh' ? '品鑑洽談' : 'Cupping & Talk',
      desc: currentLang === 'zh' ? '依需求制定方案' : 'Tailored solution',
    },
  ]

  return (
    <section id="apply" className="bg-[#F7F4EE] py-16 md:py-24">
      <div className="mx-auto max-w-[1100px] px-6 md:px-10">
        <div className="mb-12 text-center">
          <p
            className="mb-3 text-[12px] tracking-[0.22em] text-black/65"
            style={{
              fontFamily: "'EB Garamond', serif",
              fontStyle: 'italic',
              fontWeight: 400,
            }}
          >
            Free Sample
          </p>
          <h2
            className="mb-6 text-black"
            style={{
              fontFamily: "'EB Garamond', 'Noto Serif TC', serif",
              fontWeight: 400,
              fontSize: 'clamp(1.75rem, 3vw, 2.5rem)',
              letterSpacing: '0.04em',
              lineHeight: 1.25,
            }}
          >
            {currentLang === 'zh' ? '申請免費試豆樣本' : 'Request Free Sample'}
          </h2>
          <p
            className="mx-auto max-w-2xl text-[14px] leading-loose text-black/70"
            style={{
              fontFamily: "'Noto Serif TC', 'Noto Sans TC', sans-serif",
              fontWeight: 300,
              letterSpacing: '0.03em',
            }}
          >
            {currentLang === 'zh'
              ? '填寫以下表單，我們將於 24 小時內與您聯繫，安排試豆樣本（200g × 3 款）寄送，讓您在採購前充分品評風味與穩定度。'
              : 'Fill out the form below and we will contact you within 24 hours to arrange sample shipment (200g × 3 varieties) for your pre-purchase evaluation.'}
          </p>
        </div>

        {/* 3 steps */}
        <div className="mb-12 grid grid-cols-3 gap-4 border-y border-black/15 py-8">
          {steps.map((s) => (
            <div key={s.step} className="text-center">
              <div
                className="mb-2 text-2xl text-black/35"
                style={{
                  fontFamily: "'EB Garamond', serif",
                  fontWeight: 400,
                }}
              >
                {s.step}
              </div>
              <div
                className="text-sm tracking-[0.04em] text-black"
                style={{
                  fontFamily: "'Noto Serif TC', 'Noto Sans TC', sans-serif",
                  fontWeight: 400,
                }}
              >
                {s.title}
              </div>
              <div className="mt-1 text-xs text-black/55">{s.desc}</div>
            </div>
          ))}
        </div>

        {/* Form */}
        <div className="bg-white p-6 md:p-12">
          <B2BLeadForm currentLang={currentLang} />
        </div>
      </div>
    </section>
  )
}

export default WholesaleApplyFormV2
